import {
  IconButton,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Input,
  useToast,
  Box,
  HStack,
  Flex,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { CiUser } from "react-icons/ci";
import { fetchUserByAddress } from "../helpers/fetchUserByAddress";
import axios from "axios";
import { FaChevronRight } from "react-icons/fa6";

const User = ({ address }) => {
  const [user, setUser] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [infos, setInfos] = useState("");
  const [modalInfo, setModalInfo] = useState({});
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();
  const [isRegistering, setIsRegistering] = useState(false);
  const toast = useToast();
  const [userName, setUserName] = useState("");

  const fetchStuff = async () => {
    setInterval(async () => {
      const userInfo = await fetchUserByAddress(address);
      setUser(userInfo);
    }, 3000);
  };

  /*   console.log(user); */

  useEffect(() => {
    try {
      fetchStuff();
    } catch (e) {}
  }, [address]);

  const createUser = async () => {
    try {
      setIsRegistering(true);
      await axios.post(
        "https://chainpulseserver.onrender.com/api/createUser",
        {
          name: userName,
          solAddress: address,
          favorites: [], // Initialize favorites array as empty
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );

      setIsRegistering(false);
      toast({
        description: "Profile successfully created",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      setIsRegistering(false);
      toast({
        description: error?.response?.data?.error,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  /*   useEffect(() => {
    if (isModalOpen) {
      onModalClose && onOpen();
    }
  }, [isModalOpen]); */

  /*   console.log(infos); */

  const contractIndex =
    infos?.contracts &&
    infos?.contracts.findIndex((contract) => !contract.startsWith("0x"));

  const contract =
    infos?.contracts && contractIndex !== -1
      ? infos?.contracts[contractIndex]
      : null;

  const url = `https://mainnet.helius-rpc.com/?api-key=${process.env.REACT_APP_HELIUS_KEY}`;

  const getAsset = async () => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: "my-id",
        method: "getAsset",
        params: {
          id: contract,
          displayOptions: {
            showFungible: true, //return details about a fungible token
          },
        },
      }),
    });
    const { result } = await response.json();
    setModalInfo(result);
  };
  useEffect(() => {
    infos?.contracts?.length > 0 && getAsset();
  }, [infos]);

  return (
    <div>
      {/*  <Button onClick={() => fetchStuff()}>fetch stuff</Button> */}
      <IconButton onClick={onOpen} borderRadius="10px" icon={<CiUser />} />

      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="#15161a">
          <DrawerCloseButton />
          <DrawerHeader>
            {user === undefined ? "Register an account" : `Hi ${user?.name}`}
          </DrawerHeader>

          <DrawerBody>
            {user === undefined ? (
              <>
                <Input
                  onChange={(e) => setUserName(e.target.value)}
                  borderRadius="10px"
                  placeholder="Enter a username"
                />
                <Input
                  mt="10px"
                  borderRadius="10px"
                  readOnly
                  value={address?.slice(0, 30)}
                  color="gray.500"
                />
                <Button
                  isLoading={isRegistering}
                  mt="10px"
                  w="100%"
                  borderRadius="10px"
                  onClick={() => createUser()}
                >
                  Register
                </Button>
              </>
            ) : (
              <>
                <Box mb="10px">Your favorite tokens</Box>
                {user?.favorites?.map((e, i) => {
                  return (
                    <>
                      <Box
                        mt="10px"
                        p="10px"
                        w="100%"
                        borderRadius="10px"
                        bg="#222227"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => {
                          setInfos(e);
                          onClose();
                          onModalOpen();
                        }}
                      >
                        <Flex
                          w="100%"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Box>
                            <HStack>
                              <Image
                                src={e?.logo}
                                borderRadius="300px"
                                boxSize="30px"
                              />
                              <Flex
                                flexDir="column"
                                alignItems="flex-start"
                                justifyContent="flex-start"
                              >
                                <Box fontSize="12px" color="gray.500">
                                  {e?.name}
                                </Box>
                                <Box fontSize="14px">{e?.symbol}</Box>
                              </Flex>
                            </HStack>
                          </Box>

                          <FaChevronRight size="10px" />
                        </Flex>
                      </Box>
                    </>
                  );
                })}
              </>
            )}
          </DrawerBody>

          <DrawerFooter></DrawerFooter>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={isModalOpen} onClose={onModalClose}>
        <ModalOverlay />
        <ModalContent bg="#15161a" borderRadius="10px">
          <ModalHeader>{infos?.name} info and metadata</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <HStack>
              <Image
                boxSize="70px"
                borderRadius="10px"
                bg="white"
                src={infos?.logo}
              />
              <Flex
                flexDir="column"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <Box fontSize="12px" color="gray.500">
                  {infos?.name}
                </Box>

                <Box>{infos?.symbol}</Box>
                <Box>${modalInfo?.token_info?.price_info?.price_per_token}</Box>
              </Flex>
            </HStack>

            <Box w="100%" bg="#222227" borderRadius="10px" p="10px" mt="10px">
              <Flex w="100%" alignItems="center" justifyContent="space-between">
                <Box color="gray.500">Mint ID</Box>
                <Box>{modalInfo?.id?.slice(0, 30)}...</Box>
              </Flex>
            </Box>

            <Box w="100%" bg="#222227" borderRadius="10px" p="10px" mt="10px">
              <Flex w="100%" alignItems="center" justifyContent="space-between">
                <Box color="gray.500">Decimals</Box>
                <Box>{modalInfo?.token_info?.decimals}</Box>
              </Flex>
            </Box>

            <Box w="100%" bg="#222227" borderRadius="10px" p="10px" mt="10px">
              <Flex w="100%" alignItems="center" justifyContent="space-between">
                <Box color="gray.500">Current Price</Box>
                <Box>${modalInfo?.token_info?.price_info?.price_per_token}</Box>
              </Flex>
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default User;
